import styled from "styled-components";
import Flex from "../Flex";



const WrapperCurrencyInput = styled.div`
display: flex;
justify-content: space-between ;
background-color: #fff;
border-radius: 10px;
padding: 20px 0 20px 20px;
max-width: 400px;
margin-top: ${props => props.marginTop}


`
const SelectedStyled = styled.select`
font-size: 24px;
outline:none;
border:none;
width: 80px;
`

const OptionSelected = styled.option`

`
const CurrencyIcon = styled.img`
width: 40px;
hight: 40px;
border-radius: 50%;
`
const InputStyled = styled.input`
outline: none;
font-size: 24px;
border: none;
width: 130px;

`
const OneCurrencyStyled = styled.p`
font-size: 16px;
`
const SmallTextStyled = styled.p`
font-size: 16px;
color: grey;
`
const CurrencyIconWrapper = styled.div`
width: 40px;
hight: 40px;
`
const SymbCurrency = styled.p`
font-size: 20px;
padding-right: 5px;
`

const CurrencyInput = ({marginTop,smallText,symb,onChangeSelect,onChange,placeholder,smallTypeCurrencySymb,flag,smallTypeCurrency,defaultValue,value, ...props}) =>{
   
  

    return(
        <WrapperCurrencyInput marginTop={marginTop}>
            
                <Flex>
                    <CurrencyIconWrapper>
                        <CurrencyIcon  src={flag} alt="" />
                    </CurrencyIconWrapper>
                    <Flex direction='column'  marginLeft='20px'>
                        <SmallTextStyled>{smallText}</SmallTextStyled>
                        <SelectedStyled defaultValue={defaultValue} onChange={onChangeSelect}>s
                            <OptionSelected value='UAH'>UAH </OptionSelected>
                            <OptionSelected value='EUR'>EUR</OptionSelected>
                            <OptionSelected value='USD'>USD</OptionSelected>
                            <OptionSelected value='PLN'>PLN</OptionSelected>
                            <OptionSelected value='GBP'>GBP</OptionSelected>
                        </SelectedStyled>
                    </Flex>
                </Flex>
                
                  
                        <Flex alignItems='center'>
                            <SymbCurrency>{symb}</SymbCurrency>
                            <InputStyled onChange={onChange} type='text' placeholder={placeholder} readOnly={false} value={value} {...props}/>
                        </Flex>
                   
        </WrapperCurrencyInput>
    )
}

export default CurrencyInput;